import * as Yup from 'yup';
import { FormikErrors, FormikTouched } from 'formik';
import { Step as StepProps } from '@service-victoria/component-library/components/Wizard/props';
import * as Interfaces from 'interfaces';
import { constants } from 'utils';
import { Step as Identity } from '../Identity';
import Component from './Select';

type Values = Pick<Interfaces.Common.FormValues, 'prerequisiteChecks'>;

const initialValues: Values = {
  prerequisiteChecks: {
    applicantOver18: false,
    withinGuidelines: false,
    sufficientTime: false,
    sufficientSpending: false,
    CanClaimInTime: false,
    noPriorTravel: false
  }
};
const initialErrors: FormikErrors<Values> = {};
const initialTouched: FormikTouched<Values> = {};

function validateCheckbox(value: boolean) {
  return value;
}

const wizardSchema = Yup.object().shape<Interfaces.Common.PrerequisiteChecks>({
  applicantOver18: Yup.mixed().test(
    'isTicked',
    'Please tick this box to proceed.',
    validateCheckbox
  ),
  withinGuidelines: Yup.mixed().test(
    'isTicked',
    'Please tick this box to proceed.',
    validateCheckbox
  ),
  sufficientTime: Yup.mixed().test(
    'isTicked',
    'Please tick this box to proceed.',
    validateCheckbox
  ),
  sufficientSpending: Yup.mixed().test(
    'isTicked',
    'Please tick this box to proceed.',
    validateCheckbox
  ),
  noPriorTravel: Yup.mixed().test('isTicked', 'Please tick this box to proceed.', validateCheckbox),
  CanClaimInTime: Yup.mixed().test('isTicked', 'Please tick this box to proceed.', validateCheckbox)
});

const validationSchema = Yup.object().shape<Values>({
  prerequisiteChecks: wizardSchema
});

const Step: StepProps<Values> = {
  id: 'before-you-apply',
  title: constants.Page.title,
  stepName: 'Before you apply',
  validation: {
    schema: validationSchema,
    fieldNames: [
      'prerequisiteChecks.applicantOver18',
      'prerequisiteChecks.withinGuidelines',
      'prerequisiteChecks.sufficientTime',
      'prerequisiteChecks.sufficientSpending',
      'prerequisiteChecks.CanClaimInTime',
      'prerequisiteChecks.noPriorTravel'
    ]
  },
  Component,
  navigation: {
    normal: [
      {
        content: 'Next',
        shouldValidate: true,
        type: 'primary',
        onClick: (context, form) => {
          context.dispatch({
            type: 'GOTO_STEP',
            stepId: Identity.id,
            values: form.values
          });
        }
      }
    ]
  }
};

export { Step, wizardSchema, initialErrors, initialTouched, initialValues };
